export const getRelease = (name?: string) => {
  const env = process.env.DOMAIN_ENV || 'dev'
  const build = process.env.BUILD_NUMBER || 0

  return `${name || 'wlsy'}-${env}#${build}`
}
